import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GetAgreementsResponse, GetContractDocumentsResponse } from '@codegen';
import { DefaultService } from '@codegen/service';

@Injectable({
  providedIn: 'root',
})
export class AgreementsService {
  private agreementsResourceService = inject(DefaultService);

  public getProposalAgreements(
    proposalId: string
  ): Observable<GetAgreementsResponse> {
    return this.agreementsResourceService
      .agreementsGet({
        applicationId: proposalId,
        returnBase64: true,
      })
      .pipe(
        map(i => {
          const updatedAgreements = i.agreements.map(agreement => {
            return { ...agreement, mimeType: agreement.mimeType.toLowerCase() };
          });
          return { ...i, agreements: updatedAgreements };
        })
      );
  }

  public getContractAgreement(
    contractId: string
  ): Observable<GetContractDocumentsResponse> {
    return this.agreementsResourceService
      .contractsDocuments({
        contractId,
        returnBase64: true,
      })
      .pipe(
        map(i => {
          const updatedDocuments = i.documents.map(document => {
            return { ...document, mimeType: document.mimeType.toLowerCase() };
          });
          return { ...i, document: updatedDocuments };
        })
      );
  }
}
